import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Box, Text } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
const StyledText = styled(Text)`
  em {
    font-weight: ${themeGet("fontWeights.bold")};
    font-style: normal;
  }
`;
const EmptyListText = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ _jsx(Box, {
        bg: "yellow.100",
        maxWidth: [
            null,
            "500px"
        ],
        borderRadius: [
            null,
            "45px"
        ],
        my: "48px",
        mx: [
            "-16px",
            "auto"
        ],
        p: "48px",
        children: /*#__PURE__*/ _jsx(StyledText, {
            as: "p",
            lineHeight: "36px",
            fontSize: 4,
            m: "0px",
            children: children
        })
    });
};
export default EmptyListText;
